module.exports = __webpack_public_path__ + "img/xutianyi.2d2695e4.png";